import { render, staticRenderFns } from "./LiveChat.vue?vue&type=template&id=ba2e22e6&scoped=true"
import script from "./LiveChat.vue?vue&type=script&lang=js"
export * from "./LiveChat.vue?vue&type=script&lang=js"
import style0 from "./LiveChat.vue?vue&type=style&index=0&id=ba2e22e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2e22e6",
  null
  
)

export default component.exports